// You can write more code here

/* START OF COMPILED CODE */

import ForestTree1 from '@/game/prefabs/World/ForestTree1';
import Mentor5 from '@/game/prefabs/World/Mentors/Mentor5';
import Player from '@/game/prefabs/World/Player';
import Portal from '@/game/prefabs/World/Portal';
import WorldNode from '@/game/prefabs/World/WorldNode';
import TilemapScene from './TilemapScene';
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class Level24 extends TilemapScene {
  constructor() {
    super('Level24');

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  editorCreate(): void {
    // tropical_biome_4
    const tropical_biome_4 = this.add.tilemap('tropical-biome-4');
    tropical_biome_4.addTilesetImage('tropical shores', 'tropical shores');
    tropical_biome_4.addTilesetImage(
      'tropical shores prefabs & samples',
      'tropical shores prefabs & samples',
    );
    tropical_biome_4.addTilesetImage(
      'tropical shores, just trees',
      'tropical shores, just trees',
    );
    tropical_biome_4.addTilesetImage(
      'rainforest jungle 80x128 v2',
      'rainforest jungle 80x128 v2',
    );
    tropical_biome_4.addTilesetImage('collision', 'collision & alpha');

    // terrain_1
    tropical_biome_4.createLayer(
      'terrain',
      ['tropical shores prefabs & samples', 'tropical shores'],
      0,
      0,
    );

    // water_1
    tropical_biome_4.createLayer(
      'water',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // cliffs_1
    tropical_biome_4.createLayer('cliffs', ['tropical shores'], 0, 0);

    // deco_1
    tropical_biome_4.createLayer('deco', ['tropical shores'], 0, 0);

    // bushes_1
    tropical_biome_4.createLayer(
      'bushes',
      ['tropical shores, just trees', 'tropical shores'],
      0,
      0,
    );

    // tOP_cliff_edges_1
    tropical_biome_4.createLayer('TOP cliff edges', ['tropical shores'], 0, 0);

    // tOP_mountaintop_water_1
    tropical_biome_4.createLayer(
      'TOP mountaintop water',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // tOP_trees_1
    tropical_biome_4.createLayer(
      'TOP trees',
      ['tropical shores, just trees', 'rainforest jungle 80x128 v2'],
      0,
      0,
    );

    // tOP_mountaintop_water
    tropical_biome_4.createLayer(
      'TOP mountaintop water 2',
      ['tropical shores prefabs & samples'],
      0,
      0,
    );

    // cOLLISION_1
    const cOLLISION_1 = tropical_biome_4.createLayer(
      'COLLISION',
      ['collision'],
      0,
      0,
    )!;
    cOLLISION_1.visible = false;

    // player
    const player = new Player(this, 120, 200);
    this.add.existing(player);

    // worldNode
    const worldNode = new WorldNode(this, 360, 128);
    this.add.existing(worldNode);

    // worldNode_1
    const worldNode_1 = new WorldNode(this, 432, 176);
    this.add.existing(worldNode_1);

    // worldNode_2
    const worldNode_2 = new WorldNode(this, 648, 312);
    this.add.existing(worldNode_2);

    // worldNode_3
    const worldNode_3 = new WorldNode(this, 496, 216);
    this.add.existing(worldNode_3);

    // worldNode_4
    const worldNode_4 = new WorldNode(this, 320, 208);
    this.add.existing(worldNode_4);

    // worldNode_5
    const worldNode_5 = new WorldNode(this, 104, 360);
    this.add.existing(worldNode_5);

    // portal
    const portal = new Portal(this, 576, 208);
    this.add.existing(portal);

    // forestTree1
    const forestTree1 = new ForestTree1(
      this,
      504,
      352,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree1);

    // forestTree
    const forestTree = new ForestTree1(
      this,
      312,
      384,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree);

    // forestTree_1
    const forestTree_1 = new ForestTree1(
      this,
      296,
      320,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_1);

    // forestTree_2
    const forestTree_2 = new ForestTree1(
      this,
      840,
      288,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_2);

    // forestTree_3
    const forestTree_3 = new ForestTree1(
      this,
      968,
      336,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_3);

    // forestTree_4
    const forestTree_4 = new ForestTree1(
      this,
      904,
      464,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_4);

    // forestTree_5
    const forestTree_5 = new ForestTree1(
      this,
      184,
      464,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_5);

    // forestTree_6
    const forestTree_6 = new ForestTree1(
      this,
      56,
      368,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_6);

    // forestTree_7
    const forestTree_7 = new ForestTree1(
      this,
      104,
      320,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_7);

    // forestTree_8
    const forestTree_8 = new ForestTree1(
      this,
      72,
      288,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_8);

    // forestTree_9
    const forestTree_9 = new ForestTree1(
      this,
      232,
      272,
      'tropical_trees_sheet',
      0,
    );
    this.add.existing(forestTree_9);

    // forestTree_10
    const forestTree_10 = new ForestTree1(
      this,
      760,
      336,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_10);

    // forestTree_11
    const forestTree_11 = new ForestTree1(
      this,
      376,
      304,
      'tropical_trees_sheet',
      3,
    );
    this.add.existing(forestTree_11);

    // forestTree_12
    const forestTree_12 = new ForestTree1(
      this,
      536,
      336,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_12);

    // forestTree_13
    const forestTree_13 = new ForestTree1(
      this,
      456,
      336,
      'tropical_trees_sheet',
      2,
    );
    this.add.existing(forestTree_13);

    // mentor
    const mentor = new Mentor5(this, 48, 152);
    this.add.existing(mentor);

    // worldNode_6
    const worldNode_6 = new WorldNode(this, 352, 368);
    this.add.existing(worldNode_6);

    // worldNode_7
    const worldNode_7 = new WorldNode(this, 552, 320);
    this.add.existing(worldNode_7);

    // worldNode_8
    const worldNode_8 = new WorldNode(this, 648, 400);
    this.add.existing(worldNode_8);

    // worldNode_9
    const worldNode_9 = new WorldNode(this, 136, 112);
    this.add.existing(worldNode_9);

    // forestTree_14
    const forestTree_14 = new ForestTree1(
      this,
      40,
      272,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_14);

    // forestTree_15
    const forestTree_15 = new ForestTree1(
      this,
      88,
      320,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_15);

    // forestTree_16
    const forestTree_16 = new ForestTree1(
      this,
      104,
      288,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_16);

    // forestTree_17
    const forestTree_17 = new ForestTree1(
      this,
      136,
      304,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_17);

    // forestTree_18
    const forestTree_18 = new ForestTree1(
      this,
      216,
      256,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_18);

    // forestTree_19
    const forestTree_19 = new ForestTree1(
      this,
      264,
      256,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_19);

    // forestTree_20
    const forestTree_20 = new ForestTree1(
      this,
      296,
      352,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_20);

    // forestTree_21
    const forestTree_21 = new ForestTree1(
      this,
      424,
      288,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_21);

    // forestTree_22
    const forestTree_22 = new ForestTree1(
      this,
      488,
      432,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_22);

    // forestTree_23
    const forestTree_23 = new ForestTree1(
      this,
      792,
      448,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_23);

    // forestTree_24
    const forestTree_24 = new ForestTree1(
      this,
      856,
      384,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_24);

    // forestTree_25
    const forestTree_25 = new ForestTree1(
      this,
      168,
      448,
      'tropical_trees_sheet',
      4,
    );
    this.add.existing(forestTree_25);

    // worldNode (prefab fields)
    worldNode.NPCLevelId = 23;
    worldNode.NPCId = 0;

    // worldNode_1 (prefab fields)
    worldNode_1.NPCLevelId = 23;
    worldNode_1.NPCId = 1;

    // worldNode_2 (prefab fields)
    worldNode_2.NPCLevelId = 23;
    worldNode_2.NPCId = 2;

    // worldNode_3 (prefab fields)
    worldNode_3.NPCLevelId = 23;
    worldNode_3.NPCId = 3;

    // worldNode_4 (prefab fields)
    worldNode_4.NPCLevelId = 23;
    worldNode_4.NPCId = 4;

    // worldNode_5 (prefab fields)
    worldNode_5.NPCLevelId = 23;
    worldNode_5.NPCId = 5;

    // worldNode_6 (prefab fields)
    worldNode_6.NPCLevelId = 23;
    worldNode_6.NPCId = 5;

    // worldNode_7 (prefab fields)
    worldNode_7.NPCLevelId = 23;
    worldNode_7.NPCId = 5;

    // worldNode_8 (prefab fields)
    worldNode_8.NPCLevelId = 23;
    worldNode_8.NPCId = 5;

    // worldNode_9 (prefab fields)
    worldNode_9.NPCLevelId = 23;
    worldNode_9.NPCId = 5;

    this.player = player;
    this.portal = portal;
    this.mentor = mentor;
    this.tropical_biome_4 = tropical_biome_4;

    this.events.emit('scene-awake');
  }

  private player!: Player;
  private portal!: Portal;
  private mentor!: Mentor5;
  private tropical_biome_4!: Phaser.Tilemaps.Tilemap;

  /* START-USER-CODE */

  // Write your code here

  create() {
    this.editorCreate();
    this.initialize({
      camera: this.cameras.main,
      player: this.player,
      tilemap: this.tropical_biome_4,
      portal: this.portal,
      mentor: this.mentor,
    });
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
